export default __webpack_public_path__ + "static/media/houmlogo.1a2fbec3.png";